module.exports = __webpack_public_path__ + "static/media/devops.cbf8fd14.jpg";